import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, Input, message, Modal, Form, Space, DatePicker, Select, Upload } from "antd"
import { useForm } from "antd/lib/form/Form"
import TextArea from "antd/lib/input/TextArea"
import { UploadOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import { apiPrefix } from "../../../js/config"
import _ from 'lodash'

const { Option } = Select

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 }
}

interface leftAmount {
    agreement_amount: number // 合同总金额，小数类型
    total_agreement_pay_amount: number // 合同已收金额，小数类型
    total_agreement_left_amount: number // 合同待收金额，小数类型
    total_agreement_refund_amount: number // 预计退款金额，小数类型
    left_deposit: number // 剩余押金
}

interface refundMoneyData {
    check_in_amount: number // 已入住金额
    deduction_amount: number // 抵扣金额
}

interface reciveRow {
    prov_pic_list: undefined | string[], // 凭证图片集合，上传图片接口返回的图片路径
    deposit_prov_pic_list: undefined | string[]
}

interface Prop {
    storeID?: string
    onChange: () => void
}

const upLoadProps = {
    name: 'files',
    data: { fileType: 1, bucketType: 4 },
    action: apiPrefix + '/global/upload_pic',
}

export default function (prop: Prop) {

    const param: { id: string } = useParams()

    const [data, setData] = useState<leftAmount>()
    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()
    const [isRefund, setIsRefund] = useState<number>(0)

    const [reciveMoneyData, setReciveMoneyData] = useState<reciveRow[]>([{
        prov_pic_list: [],
        deposit_prov_pic_list: []
    }])

    const [reAmountVisible, setReAmountVisible] = useState<boolean>()
    const [reAmountData, setReAmountData] = useState<refundMoneyData>()

    const [isDeposit, setIsDeposit] = useState<number>(0)

    const uploadChange = (info: any, value: string) => {
        let reciveD: any = _.cloneDeep(reciveMoneyData)

        if (info.file.status === 'done') {
            message.success(`${info.file.name} 上传成功`)

            if (value === 'refund_deposit') {
                reciveD[0].deposit_prov_pic_list.push(info.file.response.data[0])
            }

            if (value === 'refund_amount') {
                reciveD[0].prov_pic_list.push(info.file.response.data[0])
            }

            setReciveMoneyData(reciveD)

        } else if (info.file.status === 'error') {
            message.error(`${info.file.name} file upload failed.`);

        } else if (info.file.status === 'removed') {
            if (value === 'refund_deposit') {
                let i = reciveD[0].deposit_prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
                reciveD[0].deposit_prov_pic_list.splice(i, 1)
            }

            if (value === 'refund_amount') {
                let i = reciveD[0].prov_pic_list.findIndex((el: string) => el === info.file.response.data[0])
                reciveD[0].prov_pic_list.splice(i, 1)
            }

            setReciveMoneyData(reciveD)
        }
    }

    useEffect(() => {
        baseAxiosNoInfo('/keeper/check_in/left_amount/info', {
            params: {
                check_in_id: param.id,
                type: 1
            }
        }).then((res: any) => {
            if (res) {
                setData(res)

                if (res.left_deposit > 0) {
                    setIsDeposit(1)
                } else {
                    setIsDeposit(0)
                }
            }
        })
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/keeper/check_in/detail/handle_ahead_check_out', {
            check_in_id: param.id,

            check_out_deposit: isDeposit,
            refund_deposit_amount: data?.left_deposit,
            refund_deposit_prov_list: reciveMoneyData[0].deposit_prov_pic_list,

            check_out_time: form.getFieldValue('check_out_time').format('YYYY-MM-DD HH:mm:ss'), // 出所时间
            check_out_way: form.getFieldValue("check_out_way"), // 出所方式
            check_out_remark: form.getFieldValue('check_out_remark'), // 出所备注
            prov_pic_list: reciveMoneyData[0].prov_pic_list,
            is_refund: form.getFieldValue("is_refund"),
            refund_amount: form.getFieldValue("refund_amount")

        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                if (prop.onChange) prop.onChange()
            }
        })
    }

    return <Fragment>
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 提前出所 */}
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>提前出所</Button>

        <Modal title="提前出所" width={700} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <Space>
                <p>合同总金额：{data?.agreement_amount}元</p>
                <p>合同已收金额：{data?.total_agreement_pay_amount}元</p>
                <p>合同待收金额：{data?.total_agreement_left_amount}元</p>
                <p>预计退款金额：{data?.total_agreement_refund_amount}元</p>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Form form={form} {...formItemLayout} >
                    <Form.Item label="出所时间" name="check_out_time" required>
                        <DatePicker showTime />
                    </Form.Item>
                    <Form.Item label="出所方式" name="check_out_way" required>
                        <Select style={{ width: 156 }} onChange={(v: number) => {
                            // baseAxiosNoInfo('/keeper/check_in/refund_amount/info', {
                            //     params: {
                            //         check_in_id: param.id,
                            //         check_out_time: form.getFieldValue('check_out_time').format('YYYY-MM-DD'),
                            //         check_out_way: form.getFieldValue("check_out_way")
                            //     }

                            // }).then((res: any) => {
                            //     res && setReAmountData(res)
                            // })
                        }}>
                            <Option key={1} value={1}>包含当天</Option>
                            <Option key={0} value={0}>不包含当天</Option>
                        </Select>
                    </Form.Item>

                    {/* <Form.Item label="是否退押金" name="check_out_deposit" required>
                        <Select style={{ width: 156 }} onChange={(v: number) => {
                            setIsDeposit(v)
                        }}>
                            <Option key={1} value={1}>是</Option>
                            <Option key={0} value={0}>否</Option>
                        </Select>
                    </Form.Item> */}

                    {isDeposit === 1 && <Fragment>
                        <Form.Item label="剩余押金">
                            {data?.left_deposit}元
                        </Form.Item>

                        {/* <Form.Item label="退押金金额" name="refund_deposit_amount" required>
                            <Input style={{ width: 156 }} />
                        </Form.Item> */}

                        <Form.Item label="退押金凭证" name="refund_deposit_prov" required>
                            <Upload {...upLoadProps} onChange={(info: any) => {
                                uploadChange(info, 'refund_deposit')
                            }}>
                                <Button icon={<UploadOutlined />} size="small" ></Button>
                            </Upload>
                        </Form.Item>
                    </Fragment>}

                    <Form.Item label="是否退款" name="is_refund" required>
                        <Select style={{ width: 156 }} onChange={(v: number) => {
                            setIsRefund(v)

                            // if (v == 0) {
                            //     setReAmountVisible(true)

                            //     baseAxiosNoInfo('/keeper/check_in/refund_amount/info', {
                            //         params: {
                            //             check_in_id: param.id,
                            //             check_out_time: form.getFieldValue('check_out_time').format('YYYY-MM-DD'),
                            //             check_out_way: form.getFieldValue("check_out_way")
                            //         }

                            //     }).then((res: any) => {
                            //         res && setReAmountData(res)
                            //     })

                            // } else {
                            //     setReAmountVisible(false)
                            // }
                        }}>
                            <Option key={1} value={1}>是</Option>
                            <Option key={0} value={0}>否</Option>
                        </Select>
                    </Form.Item>
                    {isRefund === 1 && <Fragment>
                        <Form.Item label="退款金额" name="refund_amount" required>
                            <Input style={{ width: 156 }} />
                        </Form.Item>
                    </Fragment>}

                    {/* {reAmountVisible && <Fragment>
                        <Form.Item label="已入住金额">{reAmountData?.check_in_amount}</Form.Item>
                        <Form.Item label="预抵扣金额">{reAmountData?.deduction_amount}</Form.Item>
                    </Fragment>} */}

                    <Form.Item label="上传凭证" name="check_out_prov_pic" required>
                        <Upload {...upLoadProps} onChange={(info: any) => {
                            uploadChange(info, "refund_amount")
                        }}>
                            <Button icon={<UploadOutlined />} size="small" ></Button>
                        </Upload>
                    </Form.Item>
                    <Form.Item label="出所原因" name="check_out_remark" required>
                        <TextArea style={{ height: 120, width: 220 }} />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    </Fragment>
}